import * as React from 'react';

import { withExceptionCatcher } from '@/components/hoc/with-exception-catcher';
import EtfPageLayout from '@/components/pages/etf/layout/etf-page-layout';
import type { ETFEntity } from '@/components/pages/etf/layout/components/etf-page-table';
import type { Asset } from '@/components/pages/etf/layout/components/etf-page-header';
import { IMetaProps } from '@/layout/head/default-meta';

export interface EtfControllerProps {
    meta: IMetaProps;
    asset: Asset;
    etfs: ETFEntity[];
    lastUpdated?: number;
    explanationPageContent: string;
}

export const EtfController = ({ asset, etfs, lastUpdated, explanationPageContent }: EtfControllerProps) => {
    return (
        <EtfPageLayout
            asset={asset}
            etfs={etfs}
            lastUpdated={lastUpdated}
            explanationPageHtml={explanationPageContent}
        />
    );
};

export default withExceptionCatcher(EtfController);
